import {Button, Card, CardContent, CardHeader, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useEffect, useState} from 'react';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import Results from './Results';
import {AdjustmentType, GroupMemberAdjustment} from '../../../graphql/groups.datatypes';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import {useSnackbar} from 'notistack';
import BillingPartyAdjustmentModal from '../BillingPartyAdjustmentModal';
import getBillingParty from '../getBillingParty.api';
import {BillingParty, BillingPartyAdjustment} from '../../../graphql/billing_party.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    linkButton: {
        marginRight: theme.spacing(1),
    },
}));

export const getBlankAdjustment = (groupMember: BillingParty): BillingPartyAdjustment => {
    return {
        __typename: 'BillingPartyAdjustment',
        id: -1,
        billing_party_id: groupMember.id,
        amount: 0,
        adjustment_type: AdjustmentType.DISCOUNT,
        description: '',
    };
};

export const BillingPartyAdjustmentsListContent = (props: { billingParty: BillingParty, canEdit: boolean, isAdmin: boolean, }) => {
    const classes = useStyles();
    const {billingParty, canEdit, isAdmin} = props;
    const [selectedAdjustment, setSelectedAdjustment] = useState<GroupMemberAdjustment | null>(null);

    return (
        <Card className={classes.container}>
            <CardHeader title="Billing Party Payments" action={
                isAdmin && <Button key={1} variant="contained" className={classes.linkButton}
                        onClick={() => setSelectedAdjustment(getBlankAdjustment(billingParty))}>Add Adjustment</Button>
            }/>
            <CardContent>

                {billingParty.adjustments && (
                    <Results
                        className={classes.results}
                        adjustments={billingParty.adjustments}
                        setSelectedAdjustment={setSelectedAdjustment}
                        isAdmin={isAdmin}
                    />
                )}

                {selectedAdjustment && isAdmin && (
                    <BillingPartyAdjustmentModal onClose={() => setSelectedAdjustment(null)} billingParty={billingParty}
                                                 open={true} adjustment={selectedAdjustment}
                                                 setSelectedAdjustment={setSelectedAdjustment}
                                                 isAdmin={isAdmin} canEdit={canEdit}/>
                )}
            </CardContent>
        </Card>
    );
};

const BillingPartyAdjustmentsList = () => {
    const {history, match}: RouteComponentProps<{ id: string }> = useReactRouter();
    const classes = useStyles();
    const {id} = match.params;
    const billingPartyData = getBillingParty(Number(id));
    const {enqueueSnackbar} = useSnackbar();
    const title = 'Group Member Adjustments';

    useEffect(() => {
        if (billingPartyData.error) {
            enqueueSnackbar(`There was an error loading billing Party ${id}`, {variant: 'error'});
            history.push('/');
        }
    }, [billingPartyData.error]);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="groups" title={title}/>
            <LoadingOverlay loading={billingPartyData.loading}>
                {billingPartyData.data && billingPartyData.data.billingParty && (
                    <BillingPartyAdjustmentsListContent billingParty={billingPartyData.data.billingParty} isAdmin={true}
                                                        canEdit={true}/>
                )}
            </LoadingOverlay>
        </Page>
    );
};

export default BillingPartyAdjustmentsList;
